<template>
  <v-sheet tile class="fill-height" color="#ffffff" align="center">
    <v-layout align-center column align="center">
      <br/>
      <a href="#" @click="logoClick">
        <v-img src="/static/auth_logo.svg" class="auth-logo"></v-img>
      </a>
      <br/>
      <div class="auth-elements">
        <ConfirmSignUp v-if="state == 'confirmSignUp'" :user="user"></ConfirmSignUp>
        <ForgotPassword v-if="state == 'forgotPassword'" :user="user"></ForgotPassword>
        <SignIn v-if="state == 'signedOut'" :user="user"></SignIn>
        <SignUp v-if="state == 'signUp'" :user="user"></SignUp>
      </div>
      <br/>
      <br/>
      <!--<v-flex class="help-container" align="bottom">-->
        <!--<v-btn small color="white" text href="/static/SpotSaver_privacy_policy.pdf" target="_blank">Privacy Policy-->
        <!--</v-btn>-->
        <!--<v-btn small color="white" text :to="{'name':PAGE_IDS.HOW_IT_WORKS}">How it Works</v-btn>-->
      <!--</v-flex>-->
      <!--<br/>-->
      <!--<v-flex align="bottom">-->
        <!--<v-btn small color="white" text href="mailto:team@spot-saver.com" target="_blank">Contact us-->
        <!--</v-btn>-->
      <!--</v-flex>-->
      <br/>
    </v-layout>
  </v-sheet>
</template>

<script>
  import {AmplifyEventBus} from 'aws-amplify-vue';
  import {getUser} from '../router'
  import ConfirmSignUp from "./ConfirmSignUp";
  import ForgotPassword from "./ForgotPassword";
  import SignIn from "./SignIn";
  import SignUp from "./SignUp";

  export default {
    name: "Auth",
    components: {SignIn, SignUp, ForgotPassword, ConfirmSignUp},
    data: function () {
      return {
        user: {
          username: null,
        },
        error: '',
        state: 'signedOut'
      }
    },
    async mounted() {
      AmplifyEventBus.$on('localUser', user => {
        this.user = user;
      });
      AmplifyEventBus.$on('authState', data => {
        this.updateDisplayMap(data)
      });
      this.$Amplify.Auth.currentAuthenticatedUser().then((val) => {
        if (val instanceof Error) {
          this.updateDisplayMap('signedOut')
        }
        this.user = val;
        this.updateDisplayMap('signedIn');
      })
        .catch(e => {
          this.setError(e)
          this.updateDisplayMap('signedOut');
        })

    },
    methods: {
      logoClick() {
        this.updateDisplayMap('signedOut')
      },
      updateDisplayMap(state) {
        this.state = state
        this.error = ''
      },
      setError: function (e) {
        this.error = e.message || e;
      },
    },
  }
</script>

<style lang="scss">


  .auth-elements {
    text-align: center;
    width: 400px;
    @media screen and (max-width: 599px) {
      width: 90%;
    }
    @-webkit-keyframes autofill {
      0%, 100% {
        color: inherit;
        background: transparent;
      }
    }

    input:-webkit-autofill {
      -webkit-animation-delay: 1s; /* Safari support - any positive time runs instantly */
      -webkit-animation-name: autofill;
      -webkit-animation-fill-mode: both;
    }
  }
  .help-container
  {
    display:grid;
    grid-column-gap: 1rem;
    grid-template-columns: 1fr 1fr;
  }

</style>



// WEBPACK FOOTER //
// src/Auth/Auth.vue